import FetchFactory, {
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";
import { NotificationOverview } from "./NotificationTypes";

const ENDPOINT = "/api/notifications";

type UpdateStatus = {
	read: boolean;
};

export default class NotificationClient {
	static getOverview(): GetRequest<NotificationOverview> {
		return FetchFactory.get(`${ENDPOINT}?size=0`);
	}

	static getAll(
		page = 0,
		size = 16,
		unreadOnly = false
	): GetRequest<NotificationOverview> {
		return FetchFactory.get(
			`${ENDPOINT}?page=${page}&size=${size}&unread=${unreadOnly}`
		);
	}

	static update(
		id: number,
		read: boolean
	): ModifyRequest<UpdateStatus, void> {
		const content: UpdateStatus = { read };

		return {
			operation: "PUT",
			url: `${ENDPOINT}/${id}`,
			body: content,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}

	static updateAll(): ModifyRequest<UpdateStatus, void> {
		const content: UpdateStatus = { read: true };

		return {
			operation: "PUT",
			url: `${ENDPOINT}`,
			body: content,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}
}
